import React from 'react'
import { Main } from './components'

const General = () => <Main />

export default General
